import { createRouter } from "@tanstack/react-router";

// Import the generated route tree
import { routeTree } from "./routeTree.gen";

// Create a new router instance
export const getRouter = () => {
    const router = createRouter({
        routeTree,
        context: {},

        scrollRestoration: true,
        defaultPreloadStaleTime: 0,
        defaultNotFoundComponent: () => (
            <div
                style={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "12px",
                    padding: "24px",
                    textAlign: "center",
                }}
            >
                <h1 style={{ margin: 0 }}>Page Not Found</h1>
                <p style={{ margin: 0 }}>The page you are looking for does not exist.</p>
            </div>
        ),
    });

    return router;
};
